/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  displayName: string;
  name: string;
  slaEndOfWorkday?: string;
}

export enum DataStateDto {
  INITIALIZED = "INITIALIZED",
  STORED = "STORED",
  RELEASE_PREPARED = "RELEASE_PREPARED",
  RELEASED = "RELEASED",
}

export enum DocumentTypeDto {
  COR_I = "COR_I",
  COR_II = "COR_II",
  COC = "COC",
  ABE = "ABE",
  CERT = "CERT",
  ENVELOPE = "ENVELOPE",
  COVER_LETTER = "COVER_LETTER",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
  CAR_KEY = "CAR_KEY",
  LICENSE_PLATE_FRONT = "LICENSE_PLATE_FRONT",
  LICENSE_PLATE_REAR = "LICENSE_PLATE_REAR",
  WARRANTY = "WARRANTY",
  RADIO_CODE = "RADIO_CODE",
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface KpiServiceEventPayloadDto {
  /** @format uuid */
  customerId: string;
}

export interface ReceiptListItemDto {
  /** @format int64 */
  count: number;
  /** @format uuid */
  customerId: string;
  /** @format date */
  date: string;
  receiptType: ReceiptTypeDto;
}

export interface ReceiptResultDto {
  items: ReceiptListItemDto[];
}

export enum ReceiptTypeDto {
  SCAN_COMPLETE = "SCAN_COMPLETE",
  SCAN_RECORD_COMPLETE = "SCAN_RECORD_COMPLETE",
  ACQUISITION_COMPLETE = "ACQUISITION_COMPLETE",
  ACQUISITION_RECORD_COMPLETE = "ACQUISITION_RECORD_COMPLETE",
  PLACEMENT_COMPLETE = "PLACEMENT_COMPLETE",
  PLACEMENT_RECORD_COMPLETE = "PLACEMENT_RECORD_COMPLETE",
}

export interface RepositoryListItemDto {
  /** @format int64 */
  count: number;
  /** @format uuid */
  customerId: string;
  state: DataStateDto;
  type: DocumentTypeDto;
}

export interface RepositoryResultDto {
  items: RepositoryListItemDto[];
}

export enum ShipmentTypeDto {
  MORNING = "MORNING",
  LATE_MORNING = "LATE_MORNING",
  NOON = "NOON",
  TRACKED = "TRACKED",
  POST = "POST",
}

export interface ShippingListItemDto {
  /** @format int64 */
  count: number;
  /** @format uuid */
  customerId?: string;
  /** @format date */
  date: string;
  shipmentType: ShipmentTypeDto;
}

export interface ShippingResultDto {
  items: ShippingListItemDto[];
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

export interface WeighingDataDto {
  /** weight in kg */
  amount: number;
  /** @format uuid */
  customerId: string;
  /** @format date */
  date: string;
  type: WeighingTypeDto;
}

export interface WeighingListDto {
  items: WeighingListItemDto[];
}

export interface WeighingListItemDto {
  amount: number;
  /** @format date-time */
  createdDate: string;
  customer: CustomerProjectionDto;
  /** @format uuid */
  customerId: string;
  /** @format date */
  date: string;
  /** @format uuid */
  id: string;
  type: WeighingTypeDto;
}

export enum WeighingTypeDto {
  INCOMING = "INCOMING",
  BACKLOG = "BACKLOG",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Storage Location Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Kpi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name GetCustomer
     * @request GET:/api/v1/projection/customer/{customerId}
     * @secure
     */
    getCustomer: (customerId: string, params: RequestParams = {}) =>
      this.request<CustomerProjectionDto, any>({
        path: `/api/v1/projection/customer/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Receipt
     * @name ListReceipts
     * @summary Returns a list of shipping exits
     * @request GET:/api/v1/receipt
     * @secure
     */
    listReceipts: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReceiptResultDto, any>({
        path: `/api/v1/receipt`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Repository
     * @name ListRepositoryEntries
     * @summary Returns a list of repository entries
     * @request GET:/api/v1/repository
     * @secure
     */
    listRepositoryEntries: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RepositoryResultDto, any>({
        path: `/api/v1/repository`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShippingExits
     * @name ListShippingExits
     * @summary Returns a shipping exits
     * @request GET:/api/v1/shipping-exit
     * @secure
     */
    listShippingExits: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingResultDto, any>({
        path: `/api/v1/shipping-exit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShippingReceipt
     * @name ListShippingReceipts
     * @summary Returns a shipping receipts
     * @request GET:/api/v1/shipping-receipt
     * @secure
     */
    listShippingReceipts: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingResultDto, any>({
        path: `/api/v1/shipping-receipt`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShippingRecordExits
     * @name ListShippingRecordExits
     * @summary Returns a shipping record exits
     * @request GET:/api/v1/shipping-record-exit
     * @secure
     */
    listShippingRecordExits: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingResultDto, any>({
        path: `/api/v1/shipping-record-exit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShippingRecordReceipt
     * @name ListShippingRecordReceipts
     * @summary Returns a shipping record receipts
     * @request GET:/api/v1/shipping-record-receipt
     * @secure
     */
    listShippingRecordReceipts: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingResultDto, any>({
        path: `/api/v1/shipping-record-receipt`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Weighing
     * @name ListWeighings
     * @summary Returns all weighings
     * @request GET:/api/v1/weighing
     * @secure
     */
    listWeighings: (
      query?: {
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WeighingListDto, any>({
        path: `/api/v1/weighing`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Weighing
     * @name CreateWeighing
     * @summary Create a weighing
     * @request POST:/api/v1/weighing
     * @secure
     */
    createWeighing: (data: WeighingDataDto, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/weighing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Weighing
     * @name ValidateWeighing
     * @summary Validates weighing
     * @request POST:/api/v1/weighing/validation
     * @secure
     */
    validateWeighing: (data: WeighingDataDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/weighing/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Weighing
     * @name UpdateWeighing
     * @summary Update a weighing
     * @request POST:/api/v1/weighing/{id}
     * @secure
     */
    updateWeighing: (id: string, data: WeighingDataDto, params: RequestParams = {}) =>
      this.request<WeighingDataDto, any>({
        path: `/api/v1/weighing/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
